import { render, staticRenderFns } from "./RootMenuView.vue?vue&type=template&id=5e17b51e&"
import script from "./RootMenuView.vue?vue&type=script&lang=ts&"
export * from "./RootMenuView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports